import "./App.css";

const sections = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "resources", label: "Resources" },
  { id: "contact", label: "Contact" },
  { id: "policy", label: "Policies" },
];

function App() {
  return (
    <div className="app-shell">
      <nav className="primary-nav">
        <span className="logo">Killmoe Network</span>
        <ul>
          {sections.map((section) => (
            <li key={section.id}>
              <a href={`#${section.id}`}>{section.label}</a>
            </li>
          ))}
        </ul>
      </nav>

      <header className="hero" id="about" style={{ backgroundImage: 'url("/images/hero-bg.jpg")' }}>
        <img 
          src="/uploads/hero.jpg" 
          alt="Killmoe Network - Your Gateway to Gaming and Esports" 
          style={{ width: '100%', maxHeight: '400px', objectFit: 'cover' }} 
        />
        <p className="eyebrow">Killmoe Network · Your Gateway to Innovation</p>
        <h1>Welcome to Killmoe Network</h1>
        <p className="lede">
          At Killmoe Network, we are dedicated to providing cutting-edge solutions that empower individuals and businesses alike. Our platform is designed to foster creativity, collaboration, and growth in a digital-first world. With a focus on user experience and seamless integration, we ensure that our services meet the diverse needs of our community.
        </p>
        <p>
          Our journey began with a vision to create a space where innovation thrives. We believe in the power of technology to transform lives and drive progress. From our comprehensive suite of services to our commitment to customer satisfaction, we strive to be at the forefront of the digital landscape.
        </p>
        <p>
          Explore our offerings, engage with our community, and discover how we can help you achieve your goals. Whether you are a startup looking for guidance or an established business seeking to enhance your digital presence, Killmoe Network is here to support you every step of the way.
        </p>
        <p>
          Our commitment to innovation is reflected in our diverse range of services, including web development, digital marketing, and e-commerce solutions. We understand that each client has unique needs, and we tailor our approach to ensure the best possible outcomes. With a team of experienced professionals, we are equipped to handle projects of any scale, from small businesses to large enterprises.
        </p>
        <p>
          Join us as we explore the latest trends in technology and business. Our blog features insightful articles and case studies that highlight successful strategies and innovative ideas. Stay informed and inspired by visiting our blog regularly.
        </p>
        <div className="cta-row">
          <a href="https://docs.killmoenetwork.com" target="_blank">
            Explore Our Services
          </a>
          <a href="https://blog.killmoenetwork.com" target="_blank" className="secondary">
            Visit Our Blog
          </a>
        </div>
      </header>

      <section className="cards" id="services">
        <article>
          <h2>Deploy Quickly</h2>
          <p>
            Push to GitHub and our platform will build, deploy, and host your optimized assets automatically with every commit.
          </p>
        </article>
        <article>
          <h2>Customize Freely</h2>
          <p>
            Tailor the layout, connect APIs, or drop in generated content. Our starter keeps things lightweight so you can iterate rapidly.
          </p>
        </article>
        <article>
          <h2>Automate Updates</h2>
          <p>
            Pair our services with automation tools to regenerate pages, thumbnails, and analytics on a schedule.
          </p>
        </article>
        <article>
          <h2>Monetize Responsibly</h2>
          <p>
            Every template includes AdSense-ready zones, policy pages, and clear navigation so you can activate monetization without extra setup.
          </p>
        </article>
      </section>

      <section className="resources" id="resources">
        <div className="resource-card">
          <h3>Latest Blog Posts</h3>
          <p>Check out our latest articles:</p>
          <ul>
            <li><a href="/blog/post1" target="_blank">5 Tips for Effective Digital Marketing</a></li>
            <li><a href="/blog/post2" target="_blank">How to Leverage Social Media for Growth</a></li>
            <li><a href="/blog/post3" target="_blank">The Future of E-commerce: Trends to Watch</a></li>
          </ul>
        </div>
        <div className="resource-card">
          <h3>Documentation</h3>
          <p>Review our comprehensive documentation to understand deployment, configuration, and automation.</p>
        </div>
        <div className="resource-card">
          <h3>Contact & Legal</h3>
          <p>Dedicated About, Contact, Terms, and Privacy pages are provided under /about etc.</p>
        </div>
      </section>

      <section className="contact" id="contact">
        <div>
          <h2>Contact Us</h2>
          <p>If you have questions about our services, please reach out to us.</p>
          <ul>
            <li>Email: support@killmoenetwork.com</li>
            <li>Phone: (123) 456-7890</li>
            <li>Location: Your City, USA</li>
          </ul>
        </div>
        <form>
          <label>
            Name
            <input type="text" placeholder="Jane Doe" required />
          </label>
          <label>
            Email
            <input type="email" placeholder="you@example.com" required />
          </label>
          <label>
            Message
            <textarea rows={4} placeholder="How can we help?" required />
          </label>
          <button type="submit">Send Message</button>
        </form>
      </section>

      <section className="policies" id="policy">
        <h2>Policies & Compliance</h2>
        <p>
          This site includes essential compliance resources. Customize the linked pages in{" "}
          <code>public/</code> to match your organization.
        </p>
        <ul className="policy-links">
          <li><a href="/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a></li>
          <li><a href="/terms" target="_blank" rel="noreferrer">Terms of Service</a></li>
          <li><a href="/contact" target="_blank" rel="noreferrer">Contact</a></li>
          <li><a href="/about" target="_blank" rel="noreferrer">About</a></li>
        </ul>
      </section>

      <div id="adsense" className="adsense-slot">
        <p>AdSense placeholder — replace with your ad code.</p>
      </div>

      <footer className="footer">
        <p>This site is for informational purposes only. Please consult with a professional for specific advice.</p>
      </footer>
    </div>
  );
}

export default App;